import { Component, OnInit } from '@angular/core';
import { EditArt } from 'src/app/_interfaces/EditArt';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { CustomerMainMobilePage } from 'src/app/_pages/customer-main/customer-main-mobile/customer-main-mobile.page';
import { AuthService } from 'src/app/_provider/auth.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { PopoverPage } from '../../popover/popover.page';
import { AddTicketPage } from '../../popup-content/add-ticket/add-ticket.page';
import { GeneralService } from 'src/app/_provider/general.service';

@Component({
  selector: 'cu-navigation',
  templateUrl: './cu-navigation.component.html',
  styleUrls: ['./cu-navigation.component.scss'],
})
export class CuNavigationComponent implements OnInit {

  public searchText: string = ""
  public loading: boolean = true
  

  constructor(
    public authSrv: AuthService,
    public ticketSrv: TicketCustomer.TicketService,
    public darkmode: DarkmodeService,
    private general: GeneralService,
    private feedback: FeedbackService
  ) { }

  async ngOnInit() {
    await Promise.all([this.loadTickets(), this.ticketSrv.loadCurrentAddress()])
    if(this.general.universalTicketId) {
      const ticket: TicketBase = this.ticketSrv.ticketList.find(x => x.id == this.general.universalTicketId)
      if(!ticket) return await this.feedback.showError("Sie haben keine Berechtigung, um auf dieses Ticket zuzugreifen")
      this.selectTicket(ticket)
      this.general.universalTicketId = null
    } 
  }

  public get isMobile(): boolean{
    return window.matchMedia('(max-width: 1050px)').matches
  }

  private searchTimeout
  public async searchTickets(event: KeyboardEvent){
    this.loading = true
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => this.loadTickets(), 400);
  }
  
  public async loadTickets(){
    this.ticketSrv.ticketList = []
    this.ticketSrv.selectTicket(null)
    await this.ticketSrv.getAllTicketsBase(this.searchText)
    this.loading = false
  }

  public async selectTicket(ticket: TicketBase){
    await this.ticketSrv.selectTicket(ticket)
    if(window.matchMedia("(max-width: 1050px)").matches){
      await this.feedback.openModal(CustomerMainMobilePage)
    }else{
      this.ticketSrv.workstepLoadingCount = null
    }
  }
  
  
  public toggleDarkmode(){
    this.darkmode.setDarkmode(!this.darkmode.isDarkModeValue ? "dark" : "light")
    
  }

  /**
   * Öffnen ein Popup zum erstellen eines neuen Tickets und verarbeitet die Eingaben anschließend
   */
   public async addTicket(){
    await this.feedback.openModal<TicketBase>(AddTicketPage, null, (result: HttpFunctionResult<TicketBase>)=>{
      if(!result.success) return
      var newList = [...this.ticketSrv.ticketList]
      newList.unshift(...[result.data])
      this.ticketSrv.ticketList = [...newList]
      this.ticketSrv.selectTicket(this.ticketSrv.ticketList[0])
    })

  }

  public async openHeaderMenu(event: any){
    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "customerHeaderMenu"}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      
      //1 = Theme ändern
      //2 = Refresh
      //3 = Abmelden
      switch (result.data.id) {
        case 1:
          this.toggleDarkmode()
          break;
        case 2:
          this.loadTickets()
          break;
        default:
          this.authSrv.logout(false)
          break;
      }
    }, true)
  }

}
